import { Frequency, LicenseEntitlement, QueryType, ROLES } from '../types';

export {
  formatSignNames,
  getIso7010SignImagePath,
  iso7010SignCategories,
  iso7010SignDescriptions,
  parseSignNames,
  type Iso7010SignCategory,
  type Iso7010SignCode,
} from './signs';

export const frequencies = [
  { label: 'None', value: 0 },
  { label: 'Random', value: Frequency.RANDOM },
  { label: 'Regular', value: Frequency.REGULAR },
  { label: 'Frequent', value: Frequency.FREQUENT },
  { label: 'Constant', value: Frequency.CONSTANT },
];

export const roles = [
  { label: 'Admin', value: ROLES.ROLE_ADMIN, id: 0 },
  { label: 'End User', value: ROLES.ROLE_WORKER, id: 1 },
  { label: 'Expert', value: ROLES.ROLE_EXPERT, id: 2 },
  { label: 'Super Admin', value: ROLES.ROLE_SUPERADMIN, id: 3 },
];

export const AvatarColors = [
  { backgroundColor: '#FDF8ED', color: '#C36213' },
  { backgroundColor: '#F4F7FB', color: '#336496' },
  { backgroundColor: '#F2F4FB', color: '#6a63c2' },
  { backgroundColor: '#fbfbeb', color: '#af891f' },
  { backgroundColor: '#f4f7fb', color: '#336496' },
];

export const dateFormats = {
  date: 'YYYY-MM-DD',
};

export const licenseEntitlements = [
  {
    id: LicenseEntitlement.CORE,
    title: 'Core',
    description: 'Core License',
  },
  {
    id: LicenseEntitlement.AI_DOCUMENT,
    title: 'AI Document',
    description: 'AI Document License',
  },
  {
    id: LicenseEntitlement.AI_VOICE,
    title: 'AI Voice',
    description: 'AI Voice License',
  },
  {
    id: LicenseEntitlement.AI_IMAGE,
    title: 'AI Image',
    description: 'AI Image License',
  },
  {
    id: LicenseEntitlement.USERPROFILE,
    title: 'User Profile',
    description: 'User Profile License',
  },
  {
    id: LicenseEntitlement.INSIGHT_PEOPLE,
    title: 'Insight People',
    description: 'Insight People License',
  },
];

export const suggestionTitles = {
  [QueryType.ISSUE]: 'Suggest an Issue',
  [QueryType.CASUE]: 'Suggest a Cause',
  [QueryType.ROUTINE]: 'Suggest a Routine',
};

export const suggestionReviewTitles = {
  [QueryType.ISSUE]: 'Suggested Issue',
  [QueryType.CASUE]: 'Suggested Cause',
  [QueryType.ROUTINE]: 'Suggested Routine',
};

export const EVENT_STATUS_CONFIG: Record<
  string,
  { text: string; color: string }
> = {
  CV_INIT: { text: 'In Progress', color: 'default' },
  CV_ATCL: { text: 'Auto Closed', color: 'default' },
  CV_RESL: { text: 'Resolved', color: 'success' },
  CV_ABDN: { text: 'Abandoned', color: 'warning' },
  CV_FAIL: { text: 'Failed', color: 'error' },
  RT_ATCL: { text: 'Auto Closed', color: 'default' },
  RT_RESL: { text: 'Resolved', color: 'success' },
  RT_ABDN: { text: 'Abandoned', color: 'warning' },
  RT_FAIL: { text: 'Failed', color: 'error' },
  ST_ATCL: { text: 'Auto Closed', color: 'default' },
  ST_RESL: { text: 'Resolved', color: 'success' },
  ST_ABDN: { text: 'Abandoned', color: 'warning' },
  ST_FAIL: { text: 'Failed', color: 'error' },
};
